
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chi-tiet-phan-anh/[...slug]",
      function () {
        return require("private-next-pages/chi-tiet-phan-anh/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chi-tiet-phan-anh/[...slug]"])
      });
    }
  